module.exports = __webpack_public_path__ + "static/media/Vocal_Form_4.0c04a8c4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Vocal_Form_4.pdf
// module id = 228
// module chunks = 0